



























































import {
  Vue, Prop, Component, Emit,
} from 'vue-property-decorator';
import MainButton from '@/shared/buttons/main-button.component.vue';
import Message from '@/domain/message/message';
import CalculationResult from '@/domain/calculation/entity/calculation-result.entity';
import RuleScript from '@/domain/scripts/entity/rule-script.entity';
import LabelSlot from '@/shared/slots/label-slot.component.vue';
import MetaData from '@/domain/scripts/entity/metadata.entity';
import EventBus, { Event } from '@/event.bus';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import LogComponent from '@/shared/log/log.component.vue';
import RuleScriptService from '@/domain/scripts/service/rule-script.service';
import RuleSimulateScriptRequest from '@/domain/scripts/entity/rule-simulate-script-request';
import ParameterSimulate from './parameter-simulation.component.vue';

@Component({
  components: {
    MainButton,
    LabelSlot,
    LogComponent,
    ParameterSimulate,
  },
})
export default class SimulateScriptModal extends Vue {
  @Prop({
    required: true,
  })
  showModal!: boolean;

  @Prop({
    required: true,
  })
  businessUnitId!: string;

  @Prop({
    required: true,
  })
  ruleScript!: RuleScript;

  isSimulating: boolean = false;

  calculationResult: CalculationResult = CalculationResult.of({});

  data: MetaData[] = [];

  get modalState() {
    return this.showModal;
  }

  set modalState(value: boolean) {
    this.$emit('updateModalState', value);
  }

  simulate() {
    this.isSimulating = true;
    const request = RuleSimulateScriptRequest.of(this.ruleScript);
    request.data = this.prepareDataToSend();
    RuleScriptService.simulateRuleScript(this.businessUnitId, request)
      .then((response: any) => {
        this.calculationResult = CalculationResult.of(response);
      }).catch((err: any) => VbSnackbarService.handleHttpError(err))
      .finally(() => this.isSimulating = false);
  }

  prepareDataToSend() {
    const dataObject = Object()
    this.data.forEach((el: MetaData) => {
      dataObject[el.field] = this.formatValueToSend(el.value)
    })
    return dataObject;
  }

  formatValueToSend(value: any) {
    if (!isNaN(parseFloat(value))) {
      return Number(value);
    }
    return value;
  }
}
